import apiClient from "./apiClient";

/**
 * Organizational email inbox + ACS transactional send.
 * Mirrors ClinicalTrialApi EmailCorrespondenceController responses (ApiResponse: success / message / data).
 */

export function listInboundByOrganization(organizationRefId, take = 50) {
  return apiClient.post("/api/EmailCorrespondence/ListInboundByOrganization", {
    OrganizationRefId: organizationRefId || "",
    Take: take,
  });
}

export function listInboundByStaffRecipient(params) {
  const { organizationRefId, take = 200 } = params || {};
  return apiClient.post("/api/EmailCorrespondence/ListInboundByStaffRecipient", {
    OrganizationRefId: organizationRefId || "",
    Take: take,
  });
}

export function listSentByStaff(params) {
  const { organizationRefId, take = 200, includeOrgNoreplyOutbound = false } = params || {};
  return apiClient.post("/api/EmailCorrespondence/ListSentByStaff", {
    OrganizationRefId: organizationRefId || "",
    Take: take,
    IncludeOrgNoreplyOutbound: !!includeOrgNoreplyOutbound,
  });
}

export function getSentDetail(params) {
  const {
    organizationRefId,
    emailInboundMessageId = "",
    emailOutboundMessageId = "",
    mailboxRowKind = "Inbound",
  } = params || {};
  const isOutbound = String(mailboxRowKind).toLowerCase() === "outbound";
  return apiClient.post("/api/EmailCorrespondence/GetSentDetail", {
    OrganizationRefId: organizationRefId || "",
    ...(isOutbound
      ? {
          EmailOutboundMessageId: emailOutboundMessageId || "",
          MailboxRowKind: "Outbound",
        }
      : {
          EmailInboundMessageId: emailInboundMessageId || "",
          MailboxRowKind: "Inbound",
        }),
  });
}

export function listOutboundNoreplyByOrganization(params) {
  const { organizationRefId, take = 200 } = params || {};
  return apiClient.post("/api/EmailCorrespondence/ListOutboundNoreplyByOrganization", {
    OrganizationRefId: organizationRefId || "",
    Take: take,
  });
}

export function getOutboundDetailForOrgAdmin(organizationRefId, emailOutboundMessageId) {
  return apiClient.post("/api/EmailCorrespondence/GetOutboundDetailForOrgAdmin", {
    OrganizationRefId: organizationRefId || "",
    EmailOutboundMessageId: emailOutboundMessageId || "",
  });
}

export function getOutboundDetailForStaff(organizationRefId, emailOutboundMessageId) {
  return apiClient.post("/api/EmailCorrespondence/GetOutboundDetailForStaff", {
    OrganizationRefId: organizationRefId || "",
    EmailOutboundMessageId: emailOutboundMessageId || "",
  });
}

export function listInboundByModuleRecord(params) {
  const {
    organizationRefId,
    module,
    recordId,
    take = 100,
    includeBodies = false,
  } = params || {};
  return apiClient.post("/api/EmailCorrespondence/ListInboundByModuleRecord", {
    OrganizationRefId: organizationRefId || "",
    Module: module || "",
    RecordId: recordId || "",
    Take: take,
    IncludeBodies: !!includeBodies,
  });
}

export function getInboundDetail(organizationRefId, emailInboundMessageId) {
  return apiClient.post("/api/EmailCorrespondence/GetInboundDetail", {
    OrganizationRefId: organizationRefId || "",
    EmailInboundMessageId: emailInboundMessageId || "",
  });
}

export function markInboundRead(organizationRefId, emailMessageId, options = {}) {
  const isRead =
    typeof options.isRead === "undefined" ? true : !!options.isRead;
  const readByStaffId = options.readByStaffId || "";
  const mailboxRowKind = String(options.mailboxRowKind || "Inbound");
  const isOutbound = mailboxRowKind.toLowerCase() === "outbound";
  return apiClient.post("/api/EmailCorrespondence/MarkInboundRead", {
    OrganizationRefId: organizationRefId || "",
    ...(isOutbound
      ? {
          EmailOutboundMessageId: emailMessageId || "",
          MailboxRowKind: "Outbound",
        }
      : {
          EmailInboundMessageId: emailMessageId || "",
        }),
    IsRead: isRead,
    ReadByStaffId: readByStaffId,
  });
}

export function sendOutboundTransactional(payload) {
  const attachments = Array.isArray(payload.attachments) ? payload.attachments : [];
  return apiClient.post("/api/EmailCorrespondence/SendOutboundTransactional", {
    OrganizationRefId: payload.organizationRefId || "",
    Module: payload.module || "",
    RecordId: payload.recordId || "",
    DisplayFromName: payload.displayFromName || "",
    ToAddress: payload.toAddress || "",
    Subject: payload.subject || "",
    bodyText: payload.bodyText || "",
    bodyHtml: payload.bodyHtml || "",
    Attachments: attachments,
  });
}

export function getOperationalDiagnostics() {
  return apiClient.post("/api/EmailCorrespondence/GetOperationalDiagnostics", {});
}
